module.exports = __webpack_public_path__ + "273b5a8564b95190c4537692a5cac3f9.svg";